import React, { useState, useEffect } from "react";
import { MultiSelect } from "primereact/multiselect";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as Fa from "react-icons/fa";
import {
    createAPIEndpointHoldProductForAutoAllocation,
    EndpointHoldProductForAutoAllocation,
} from "../../Services/HoldProductForAutoAllocation/HoldProductForAutoAllocationService";
import storage from "../../Services/Storage";
import { toast } from "react-toastify";

const HoldProductForAutoAllocation = () => {
    const [productData, setProductData] = useState();
    const [productDataTable, setProductDataTable] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const auth = storage.getLocal("user");

    const getProduct = async () => {
        try {
            const res = await createAPIEndpointHoldProductForAutoAllocation().get(
                `${EndpointHoldProductForAutoAllocation.PopulateProduct}?CompId=${auth.CompId}&dataType=N`
            );
            const resdataAll =
        await createAPIEndpointHoldProductForAutoAllocation().get(
            `${EndpointHoldProductForAutoAllocation.PopulateProduct}?CompId=${auth.CompId}&dataType=Y`
        );
            setProductData(res.data.Data);
            setProductDataTable(resdataAll.data.Data);
        } catch (error) {
            console.log("error ", error);
        }
    };

    const createPayload = (outgoingPageNo, data) => {
        let objProd;
        if (outgoingPageNo == "Y") {
            objProd = data?.map((product) => ({
                prodCode: product.PROD_CODE,
            }));
        } else {
            let convData = [data];
            objProd = convData?.map((product) => ({
                prodCode: product.PROD_CODE,
            }));
        }
        const payload = {
            compId: auth.CompId,
            outgoinG_PAGE_NO: outgoingPageNo,
            objProd: objProd,
        };

        return payload;
    };

    const submitData = (outgoingPageNo, data) => {
        if (outgoingPageNo == "Y" && selectedProducts.length == 0) {
            toast.warning("Please select products", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            return;
        }
        const payload = createPayload(outgoingPageNo, data);
        createAPIEndpointHoldProductForAutoAllocation()
            .post(
                `${EndpointHoldProductForAutoAllocation.SaveDeleteExclude}`,
                payload
            )
            .then((res) => {
                toast.success(`${res.data.Message}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });

                getProduct();
                setSelectedProducts([]);
            })
            .catch((error) => {
                toast.error("Something Went Wrong.", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                console.log(error);
            });
    };

    const removeData = (rowData) => {
        submitData("N", rowData);
    // const updatedProducts = excluData.filter(
    //     (product) => product.PROD_CODE !== rowData.PROD_CODE
    // );
    // setExcluData(updatedProducts);
    };

    useEffect(() => {
        getProduct();
    }, []);

    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Hold Product For AutoAllocation</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12"></div>
                </div>
                <section className="">
                    <div className="sales-box">
                        <div className="row d-flex justify-content-end align-items-end">
                            <div className="col-lg-8 col-md-6 col-sm-12">
                                <label className="form-label">Product</label>
                                <MultiSelect
                                    options={productData}
                                    value={selectedProducts}
                                    onChange={(e) => setSelectedProducts(e.value)}
                                    optionLabel="PROD_SMALL_DESC"
                                    placeholder="Select products"
                                    className="w-100"
                                    filter
                                    resetFilterOnHide
                                />
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <div className="text-end">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => submitData("Y", selectedProducts)}
                                    >
                    Hold
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="DataTable pt-1">
                        <h3 className="py-2">Records</h3>
                        <DataTable
                            value={productDataTable}
                            dataKey="PROD_SMALL_DESC"
                            paginator
                            rows={10}
                            filterDisplay="row"
                            scrollable
                            rowsPerPageOptions={[10, 25, 50]}
                            scrollHeight="80vh"
                            // showGridlines
                            stripedRows
                            emptyMessage="No Data found."
                        >
                            <Column
                                field="PROD_SMALL_DESC"
                                header="Product"
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Search Here..."
                                style={{ minWidth: "12rem" }}
                            />
                            <Column
                                header="Action"
                                headerStyle={{ width: "10rem" }}
                                body={(rowData) => (
                                    // <i
                                    //     className="pi pi-trash"
                                    //     style={{
                                    //         color: "red",
                                    //         cursor: "pointer",
                                    //         marginLeft: "4px",
                                    //     }}
                                    //     onClick={() => removeData(rowData)}
                                    // ></i>
                                    <button
                                        className="grid-icon"
                                        onClick={() => removeData(rowData)}
                                        title="Delete"
                                    >
                                        <Fa.FaTrashAlt className="cancel"/>
                                    </button>
                                )}
                            />
                        </DataTable>
                    </div>
                </section>
            </div>
        </>
    );
};

export default HoldProductForAutoAllocation;
